import React from 'react';
import { FileText, Download, Shield, Lock } from 'lucide-react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
const documents = [{
  title: 'Loan Application Form',
  description: 'Download the official De Rien Cash Loan Application Form. Includes personal details, employment information, references, and loan declaration section.',
  href: 'https://derien.co.bw/Documents/Loan%20Application%20form%202024%20updated.pdf',
  delay: 0.1
}, {
  title: 'Personal Loan Agreement',
  description: 'Official loan agreement document outlining loan terms, interest, repayment structure, and next-of-kin details.',
  href: 'https://derien.co.bw/Documents/De%20Rien%20Cash%20loan%20Agreement.pdf',
  delay: 0.2
}];
export function FormsDocuments() {
  return <Section id="forms" bg="offwhite" data-id="element-133">
      {/* Header */}
      <div className="text-center mb-12" data-id="element-134">
        <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-135">
          Forms & Documents
        </h2>
        <h3 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-136">
          Download official De Rien Cash Loan documents below.
        </h3>
        <div className="flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-137">
          <Lock className="h-4 w-4 text-gold" data-id="element-138" />
          <p data-id="element-139">Secure. Official. Updated documents for your convenience.</p>
        </div>
      </div>

      {/* Document Cards */}
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-140">
        {documents.map(doc => <Card key={doc.title} delay={doc.delay} className="flex flex-col" data-id="element-141">
            {/* Icon + Title */}
            <div className="flex items-start gap-4 mb-4" data-id="element-142">
              <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center" data-id="element-143">
                <FileText className="h-6 w-6 text-gold" data-id="element-144" />
              </div>
              <div data-id="element-145">
                <h4 className="text-lg font-bold text-navy leading-snug" data-id="element-146">
                  {doc.title}
                </h4>
              </div>
            </div>

            {/* Description */}
            <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-147">
              {doc.description}
            </p>

            {/* Divider */}
            <div className="border-t border-gray-100 pt-4" data-id="element-148">
              <a href={doc.href} target="_blank" rel="noopener noreferrer" data-id="element-149">
                <Button variant="primary" size="sm" className="w-full gap-2" data-id="element-150">
                  <Download className="h-4 w-4" data-id="element-151" />
                  Download PDF
                </Button>
              </a>
            </div>
          </Card>)}
      </div>

      {/* Trust note */}
      <div className="flex items-center justify-center gap-2 mt-10 text-gray-400 text-xs" data-id="element-152">
        <Shield className="h-4 w-4 text-gold" data-id="element-153" />
        <span data-id="element-154">
          All documents are official and sourced directly from De Rien Cash Loan
          (PTY) Ltd.
        </span>
      </div>
    </Section>;
}